module.exports = __webpack_public_path__ + "static/media/espiga_especial.57a701f6.png";